<template>
  <div>
  <my-request-layout
    :workflowGuid="registration.workflowGuid"
    :foundRequest="!!registration"
    :isLoading="isLoading"
    :myRequest="registration"
    :makePayment="makePayment"
    :cancelRequest="cancelRequest"
    :paymentStatus="paymentStatus"
  >
    <span slot="title"
      >Lease Agreement <localized-date :date="registration.startDate" /> -
      <localized-date :date="registration.endDate" /></span
    >

    <div slot="requestContent" v-if="registration && registration.leasedDog">
      <lease-request :registration="registration"> </lease-request>
    </div>
  </my-request-layout>
  <v-snackbar v-model="showErrorMessage" title color="error">
    {{ errorMessage }}
    <template v-slot:action="{ attrs }">
    <v-btn color="primary" text v-bind="attrs" @click="showErrorMessage = false">
      Close
    </v-btn>
    </template>
  </v-snackbar>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import MyRequestLayout from "@/components/Portal/MyRequest/MyRequestLayout.vue";
import LeaseRequest from "@/components/Portal/MyRequest/LeaseRequest.vue";

import workflowService from "@/services/portal/workflowService";

import { UserInfo } from "@/types/User";
import AuthorizeNetResponseData from "@/types/AuthorizeNetResponseData";

export default Vue.extend({
  name: "MyLeaseRequest",
  components: {
    MyRequestLayout,
    LeaseRequest,
  },
  data: function () {
    return {
      registration: Object as any,
      isLoading: false,
      paymentStatus: null,
      errorMessage: "",
      showErrorMessage: false,
    };
  },
  props: {
    workflowGuid: { type: String },
  },
  methods: {
    load() {
      this.isLoading = true;
      workflowService
        .getLeaseRequestDetails(this.workflowGuid)
        .then((res) => {
        this.isLoading = false;
        this.registration = res;
      });
    },
    makePayment: function (paymentInfo: AuthorizeNetResponseData) {
      var req = {
        paymentInfo,
        workflowGuid: this.registration.workflowGuid,
      };

      workflowService.submitLeaseCCPayment(req).then(res => {
        if (res.error) {
          this.errorMessage = res.error;
          this.showErrorMessage = true;
        }
        else {
          this.paymentStatus = res;
        }

        this.load();
      });
    },
    cancelRequest: function () {
    },
  },
  created() {
    this.load();
  },
  watch: {
    workflowGuid: function (newValue) {
      this.load();
    },
  },
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    },
  },
});
</script>
